import { z } from 'zod';

const selectOptionSchema = z.object({
  value: z
    .union([z.string(), z.number()])
    .refine((value) => Number.isInteger(Number(value)) && Number(value) > 0),
  label: z.string(),
});

export const companyDocumentSchema = z.object({
  file: z
    .instanceof(File)
    .or(z.never().nullish())
    .transform((value) => value ?? undefined),
  name: z.string().min(1).max(255),
  documentCategoryId: selectOptionSchema,
  buslineIds: z.array(selectOptionSchema).optional(),
});

export type ICompanyDocument = z.infer<typeof companyDocumentSchema>;
